export default __webpack_public_path__ + "static/cat-07ae5537412181213d3f15d2a830cd46.svg";